import { render, staticRenderFns } from "./InternalCurrency.vue?vue&type=template&id=4055b13c&scoped=true"
import script from "./InternalCurrency.vue?vue&type=script&lang=js"
export * from "./InternalCurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4055b13c",
  null
  
)

export default component.exports